export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10370.9b0d237a.jpg";